/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cgvapprovalMutationVariables = {||};
export type cgvapprovalMutationResponse = {|
  +user: ?{|
    +response: ?{|
      +code: ?number,
      +message: ?string,
    |}
  |}
|};
export type cgvapprovalMutation = {|
  variables: cgvapprovalMutationVariables,
  response: cgvapprovalMutationResponse,
|};
*/


/*
mutation cgvapprovalMutation {
  user {
    response: cgvApproval {
      code
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserMutation",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": "response",
        "args": null,
        "concreteType": "UserPayloadMutation",
        "kind": "LinkedField",
        "name": "cgvApproval",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "cgvapprovalMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "cgvapprovalMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "20f809032977a7487de0a9558ef90b18",
    "id": null,
    "metadata": {},
    "name": "cgvapprovalMutation",
    "operationKind": "mutation",
    "text": "mutation cgvapprovalMutation {\n  user {\n    response: cgvApproval {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fe13e6b2fa43ceaa3ed81c051fbb37b7';

module.exports = node;
